import React, { Component } from 'react';
import { Container, Row, Col, Button, Spinner, Form, FormGroup, Input } from 'reactstrap';
import { subscriberService } from '../../services/subscriber-service';
import Toast from '../common/custom-controls/Toast';
import NicSummary from './NicSummary';
import { nicValidation } from './../../utils/validations';
import '../custom.css';

class NicSummaryView extends Component {
    _isMounted = false;
    INITIAL_STATE = {
        showLoadingSpinner: true,
        toast: {
            type: '',
            message: ''
        },
        searchInputField: {
            nic: ''
        },      
    }
    constructor(props) {
        super(props);
        this.state = {
            ...this.INITIAL_STATE
        }
    }

    componentDidMount() {
        this._isMounted = true;
        this.loadSubscriber();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    redirectToNewUser(nic) {
        subscriberService.getSubscribersByNic(nic).then((results) => {
            if (results.data.id) {
                this.props.history.push(`/subscribers/id/${results.data.id}`, { nic: nic});
                this.setState({
                    showLoadingSpinner: true
                })
                this.componentDidMount();
            }
        }).catch((error) => {
            this.setState({
                showLoadingSpinner: true,
                toast: {
                    type: 'warning',
                    message: error.message
                }
            })
        });
    }

    handleExit = () => {
        this.redirectToLotteries();
    }

    loadSubscriber = () => {
        if (this.props.match.params && this.props.location.state) {
            const { id } = this.props.match.params;
            const nic = this.props.location.state.nic;

            subscriberService.getSubscribers(id)
                .then((results) => {
                    if (!this._isMounted) return;

                    if (results.statusCode === 200) {
                        this.setState({
                            showLoadingSpinner: false,
                            subscribersData: {
                                ...results.data,
                                nicNumber: nic
                            }
                        });
                    } else {
                        this.setState({
                            showLoadingSpinner: false,
                            toast: {
                                type: 'warning',
                                message: results.data.description
                            }
                        });
                    }
                })
                .catch((error) => {
                    if (!this._isMounted) return;

                    this.setState({
                        toast: {
                            type: 'warning',
                            message: error.message
                        }
                    });
                });
        } else {
            this.redirectToLotteries();
        }
    };


    handleModalClose = (user) => {
        if (user.message) {
            this.setState({
                toast: {
                    type: 'success',
                    message: user.message
                }
            })

            if (user.nic) {
                this.redirectToNewUser(user.nic);
            } else {
                this.componentDidMount();
            }
        }

        this.setState({
            showSubscriptionModal: false
        });
    }

    handleValueChange = (e) => {
        let searchInputField = { ...this.state.searchInputField };
        searchInputField[e.target.name] = e.target.value;
        this.setState({
            searchInputField
        });

    }

    handleUpdate = () => {
        this.setState({ showLoadingSpinner: true })
        this.componentDidMount();
    };

    handleToastClose = (status) => {
        if (!status) {
            this.setState({
                toast: {
                    type: '',
                    message: ''
                }
            })
        }
    }

    handleOnSearch = (toast) => {
        if (toast.message) {
            this.setState({
                toast
            })
        }

    }

    handleSearch = () => {
        const { searchInputField } = this.state;

        if (searchInputField.nic && nicValidation(searchInputField.nic)) {
            subscriberService.getSubscribersByNic(searchInputField.nic).then((results) => {
                if (results.statusCode === 200) {
                    this.props.history.push(`/subscribers/id/${results.data.id}`, { nic: searchInputField.nic});
                    this.setState({
                        showLoadingSpinner: true,
                        searchInputField: {
                            nic: ''
                        }
                    })
                    this.componentDidMount();
                } else {
                    this.setState({
                        toast: {
                            type: 'warning',
                            message: results.data.description
                        }
                    })
                }
            }).catch((error) => {
                this.setState({
                    toast: {
                        type: 'warning',
                        message: error.message
                    }
                })
            });
        } else {
            this.setState({
                toast: {
                    type: 'warning',
                    message: 'NIC number is not valid'
                }
            })
        }
    }

    render() {
        const { toast, showLoadingSpinner, subscribersData, searchInputField } = this.state;

        return (
            <Container fluid>
                <Toast handleOnClose={this.handleToastClose} isOpen={toast.message ? true : false} type={toast.type} message={toast.message}></Toast>
                <div>
                    <Row>
                        <Col md={8}>
                            <label><h4>Subscribers</h4></label>
                        </Col>
                        <Col md={4} className="text-right pl-2">
                            <Form inline>
                                <FormGroup row>
                                    <Input
                                        className='form-control-rounded'
                                        type="tel" name={'nic'}
                                        maxLength="12" id="nic"
                                        placeholder={'NIC Number'}
                                        onChange={this.handleValueChange}
                                        value={searchInputField.nic} />
                                    <span className="mr-3">
                                    </span>
                                    <Button className='btn-rounded' color="primary" onClick={() => this.handleSearch()}><i className="fas fa-search"></i> Search</Button>
                                </FormGroup>
                            </Form>
                        </Col>
                    </Row>

                </div>

                {showLoadingSpinner ?
                    <Row className="border bg-white px-3 pt-3 pb-2 mt-2 shadow-sm">
                        <Col md={12} className="text-center">
                            <Spinner color="primary" />
                        </Col>

                    </Row> :
                    <div>
                        <div style={{}} className="border bg-white shadow-sm mt-2">
                            <div className="classic-tabs" >
                                <ul className="nav tabs-primary border-bottom" id="myClassicTab" role="tablist" style={{ fontSize: '15px', padding: '5px', borderRadius: '.5rem' }}>
                                    <li className="nav-item" >
                                        <a className="nav-link waves-light active show text-muted" id="profile-tab-classic" data-toggle="tab" href="#package-summary"
                                            role="tab" aria-controls="profile-classic" aria-selected="true">NIC Summary</a>
                                    </li>
                                </ul>

                                <div className="tab-content border-right border-bottom border-left rounded-bottom" id="myClassicTabContent">
                                    <div className="tab-pane fade active show" id="package-summary" role="tabpanel" aria-labelledby="profile-tab-classic">
                                        <NicSummary onSearch={this.handleOnSearch} userData={subscribersData} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </Container >
        )
    }
}

export default NicSummaryView;
